import { CardInformativeTitleVariants } from './card-informative-title.styles'

type CardInformativeTitleProps = {
  children: React.ReactNode
}

export const CardInformativeTitle = (props: CardInformativeTitleProps) => {
  const { children } = props

  return (
    <p {...props} className={CardInformativeTitleVariants({})}>
      {children}
    </p>
  )
}
